import classes from "./EquipmentContainer.module.css";
import { EquipmentBookingActions } from "./EquipmentBookingActions";
import { useTextTruncate } from "../../hooks/useTextTruncate";

const EQUIPMENT_TITLE_MAX_CHARS = 20;

function EquipmentCardTitle({ title }) {
    const { textRef, containerRef, truncatedText } = useTextTruncate(title || "", {
        maxChars: EQUIPMENT_TITLE_MAX_CHARS,
        charsToReplace: 3,
        multiline: true,
    });
    return (
        <h3 ref={containerRef} className={`${classes.equipmentTitle} titleSemibold3`}>
            <span ref={textRef} className={classes.equipmentTitleMeasure}>
                {truncatedText}
            </span>
        </h3>
    );
}

function stockLabel(n) {
    const x = typeof n === "number" ? n : parseInt(String(n), 10);
    if (!Number.isFinite(x) || x < 0) return null;
    return `${x} Stück`;
}

export const EquipmentContainer = ({
    equipmentItemId,
    counts = 0,
    name,
    price,
    image,
    counted,
    checked = false,
    maxCount = 1,
    onOpenDetails,
}) => {
    const stock = stockLabel(maxCount);

    return (
        <div className={classes.container}>
            <div className={classes.bodyColumn}>
                <div className={classes.equipmentImage}>
                    {image ? <img src={image} alt={name} /> : null}
                </div>
                <div className={classes.equipmentInfo}>
                    <EquipmentCardTitle title={name} />
                    <div className={classes.priceRowCard}>
                        <p className={`${classes.priceInline} regularLarge`}>{price}</p>
                        {stock ? <span className={`${classes.stockPillCard} semiboldXxs`}>{stock}</span> : null}
                    </div>
                    <button
                        type="button"
                        className={`${classes.detailsButton} semiboldXs`}
                        onClick={() => onOpenDetails?.()}
                    >
                        Details öffnen
                    </button>
                </div>
            </div>
            <div className={classes.horizontalLine}></div>
            <EquipmentBookingActions
                onOpenDetails={onOpenDetails}
                equipmentItemId={equipmentItemId}
                name={name}
                price={price}
                maxCount={maxCount}
                counted={counted}
                counts={counts}
                checked={checked}
                layout="card"
            />
        </div>
    );
};

export default EquipmentContainer;
